/* ================================================================
   Cookie Pack Builder — <cookie-pack-builder> Web Component
   Owner: fe-dev
   ================================================================ */

(() => {
  if (customElements.get('cookie-pack-builder')) return;

  // --- Inline SVG sprite map for trust-signal icons ---
  const TRUST_ICONS = {
    cookie:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><circle cx="9" cy="10" r="0.9" fill="currentColor"/><circle cx="14.5" cy="9" r="0.9" fill="currentColor"/><circle cx="13" cy="14.5" r="0.9" fill="currentColor"/></svg>',
    variety:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="9" r="4"/><circle cx="16" cy="9" r="4"/><circle cx="12" cy="16" r="4"/></svg>',
    capricho:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.5-7 10-7 10z"/></svg>',
    gluten_free:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3c-3 5-7 6-7 11a7 7 0 0 0 14 0c0-5-4-6-7-11z"/><path d="M9 13c1 1 4 1 6-1"/><path d="M3 3l18 18"/></svg>',
    dedicated:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2l2.5 5 5.5.8-4 3.9.9 5.5L12 14.7 7.1 17.2 8 11.7 4 7.8l5.5-.8L12 2z"/></svg>',
    barcelona:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s7-7 7-12a7 7 0 0 0-14 0c0 5 7 12 7 12z"/><circle cx="12" cy="10" r="2.4"/></svg>',
    handmade:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 11V5a1.5 1.5 0 0 1 3 0v5"/><path d="M12 10V4a1.5 1.5 0 0 1 3 0v7"/><path d="M15 10V6a1.5 1.5 0 0 1 3 0v9a6 6 0 0 1-6 6h-1c-2 0-3-1-4-2l-3-5c-.6-1 .2-2 1-1.5l3 1.5"/></svg>',
    delivery:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
    chef_hat:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 14a3.5 3.5 0 0 1-1.5-6.66A4 4 0 0 1 12 5a4 4 0 0 1 6.5 2.34A3.5 3.5 0 0 1 17 14"/><path d="M7 14h10v5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"/><path d="M10 14v6"/><path d="M14 14v6"/></svg>',
    assortment:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="7" cy="7" r="3"/><circle cx="17" cy="7" r="3"/><circle cx="7" cy="17" r="3"/><circle cx="17" cy="17" r="3"/></svg>',
    sparkle:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3l1.6 4.4L16 9l-4.4 1.6L10 15l-1.6-4.4L4 9l4.4-1.6z"/><path d="M18 14l.7 1.8L20.5 16.5l-1.8.7L18 19l-.7-1.8L15.5 16.5l1.8-.7z"/></svg>',
  };

  /**
   * Format an amount in cents using Shopify's `shop.money_format`.
   * Falls back to Intl.NumberFormat when format string is unavailable.
   */
  const formatMoney = (cents, format, currency) => {
    if (typeof cents !== 'number' || Number.isNaN(cents)) return '';
    const fallback = () => {
      try {
        return new Intl.NumberFormat('es-ES', {
          style: 'currency',
          currency: currency || 'EUR',
        }).format(cents / 100);
      } catch {
        return `€${(cents / 100).toFixed(2)}`;
      }
    };

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, format); } catch { /* fall through */ }
    }

    if (!format) return fallback();

    const placeholderRe = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(placeholderRe);
    if (!match) return fallback();

    let value;
    switch (match[1]) {
      case 'amount':
        value = (cents / 100).toFixed(2).replace('.', ',');
        break;
      case 'amount_no_decimals':
        value = String(Math.round(cents / 100));
        break;
      case 'amount_with_comma_separator':
        value = (cents / 100).toFixed(2).replace('.', ',');
        break;
      case 'amount_with_space_separator':
        value = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = String(Math.round(cents / 100));
        break;
      case 'amount_no_decimals_with_space_separator':
        value = String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        break;
      default:
        return fallback();
    }
    return format.replace(placeholderRe, value);
  };

  class CookiePackBuilder extends HTMLElement {
    constructor() {
      super();
      this.state = {
        variantId: '',
        variantTitle: '',
        priceCents: 0,
        maxCount: 0,
        // Map preserves insertion order — needed for FIFO trim and
        // capacity-grid filling. Key = slug.
        selections: new Map(),
        isSubscribing: false,
        giftMessage: '',
        isComplete: false,
        isSubmitting: false,
      };

      this.lastFocusedTrigger = null; // for modal focus return
      this.toastTimer = null;
      this.completePulseTimer = null;
    }

    /* ------------------------------------------------------------
       Lifecycle
       ------------------------------------------------------------ */
    connectedCallback() {
      this.cacheRefs();
      this.cacheRootData();
      this.renderTrustIcons();
      this.bindEvents();
      this.populateInitialState();
      this.renderAll();
    }

    disconnectedCallback() {
      if (this.toastTimer) clearTimeout(this.toastTimer);
      if (this.completePulseTimer) clearTimeout(this.completePulseTimer);
    }

    /* ------------------------------------------------------------
       Cache DOM refs once — never re-query in hot paths
       ------------------------------------------------------------ */
    cacheRefs() {
      this.refs = {
        tierGroup:        this.querySelector('.cpb-tiers'),
        tierButtons:      Array.from(this.querySelectorAll('.cpb-tier')),
        flavorGrid:       this.querySelector('.cpb-flavors__grid'),
        flavorCards:      Array.from(this.querySelectorAll('.cpb-flavor')),
        capacityGrid:     this.querySelector('[data-capacity-grid]'),
        capacitySlots:    Array.from(this.querySelectorAll('[data-slot-index]')),
        progress:         this.querySelector('[data-progress]'),
        summaryEmpty:     this.querySelector('[data-summary-empty]'),
        summaryProgress:  this.querySelector('[data-summary-progress]'),
        selectedCount:    this.querySelector('[data-selected-count]'),
        capacityText:     this.querySelector('[data-capacity]'),
        completeCaption:  this.querySelector('[data-complete-caption]'),
        totalPrice:       this.querySelector('[data-total-price]'),
        totalWrap:        this.querySelector('[data-total-wrap]'),
        ctas:             Array.from(this.querySelectorAll('[data-add-to-cart]')),
        ctaTexts:         Array.from(this.querySelectorAll('[data-cta-text]')),
        ctaSpinners:      Array.from(this.querySelectorAll('[data-cta-spinner]')),
        giftInput:        this.querySelector('[data-gift-input]'),
        giftWordCount:    this.querySelector('[data-gift-word-count]'),
        subToggle:        this.querySelector('[data-subscription-toggle]'),
        subOptions:       Array.from(this.querySelectorAll('[data-subscription-option]')),
        toastRegion:      this.querySelector('[data-toast-region]'),
        modalTemplate:    this.querySelector('[data-trim-modal-template]'),
        summary:          this.querySelector('[data-summary]'),
        trustIcons:       Array.from(this.querySelectorAll('[data-trust-icon]')),
        mobileBar:        this.querySelector('[data-mobile-bar]'),
        mobileProgress:   this.querySelector('[data-mobile-progress]'),
        mobileCapacity:   this.querySelector('[data-mobile-capacity]'),
      };
    }

    cacheRootData() {
      const ds = this.dataset;
      this.config = {
        productId:       ds.productId,
        productHandle:   ds.productHandle,
        currency:        ds.currency || 'EUR',
        moneyFormat:     ds.moneyFormat || '',
        spGroupId:       ds.spGroupId || '',
        spPlanId:        ds.spPlanId || '',
        spDiscountPct:   parseInt(ds.spDiscountPct, 10) || 0,
      };

      // Initial tier = first tier button (which already has aria-checked="true")
      const initialTier = this.refs.tierButtons.find(
        (b) => b.getAttribute('aria-checked') === 'true'
      ) || this.refs.tierButtons[0];

      if (initialTier) {
        this.state.variantId    = initialTier.dataset.variantId;
        this.state.variantTitle = initialTier.dataset.tierName;
        this.state.priceCents   = parseInt(initialTier.dataset.priceCents, 10) || 0;
        this.state.maxCount     = parseInt(initialTier.dataset.cookieCount, 10) || 0;
      }
    }

    /* ------------------------------------------------------------
       Render: trust icons (inject inline SVGs by `data-trust-icon` key)
       ------------------------------------------------------------ */
    renderTrustIcons() {
      this.refs.trustIcons.forEach((slot) => {
        const key = slot.dataset.trustIcon;
        const svg = TRUST_ICONS[key] || TRUST_ICONS.cookie;
        slot.innerHTML = svg;
      });
    }

    /* ------------------------------------------------------------
       Initial flavor card decoration: aria-label baseline already set
       in Liquid; nothing to do unless we need to seed selections.
       Capacity-warning is auto-shown if max === 0.
       ------------------------------------------------------------ */
    populateInitialState() {
      // If default tier has no capacity (metafield missing), surface a warning
      // We don't have a dedicated warning element from be-dev's markup, so we
      // append one inline above the summary as a graceful fallback.
      if (this.state.maxCount === 0 && this.refs.tierButtons.length > 0) {
        const warn = document.createElement('div');
        warn.className = 'cpb-warning';
        warn.setAttribute('role', 'alert');
        warn.textContent =
          'Configuración pendiente: no se ha definido la capacidad de este pack. Avisa al equipo.';
        if (this.refs.summary && this.refs.summary.parentNode) {
          this.refs.summary.parentNode.insertBefore(warn, this.refs.summary);
        }
      }
    }

    /* ------------------------------------------------------------
       Event wiring (delegation on root)
       ------------------------------------------------------------ */
    bindEvents() {
      // Click delegation for tiers, flavor cards, steppers, sub-toggle, CTA
      this.addEventListener('click', this.onClick);

      // Keyboard support on tier radios (Arrow keys per WAI-ARIA radiogroup pattern)
      if (this.refs.tierGroup) {
        this.refs.tierGroup.addEventListener('keydown', this.onTierKeydown);
      }

      // Gift input
      if (this.refs.giftInput) {
        this.refs.giftInput.addEventListener('input', this.onGiftInput);
      }

      // CTA dedicated handler — separate from delegation so we can submit.
      // Both rail and mobile-bar CTAs share the same data-attribute and handler.
      this.refs.ctas.forEach((cta) => cta.addEventListener('click', this.onSubmit));

      // Custom upgrade event from toast (`Subir pack` button)
      this.addEventListener('cpb:upgrade-tier', this.onUpgradeTier);
    }

    onClick = (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;

      // Tier card
      const tierBtn = target.closest('.cpb-tier');
      if (tierBtn && this.contains(tierBtn)) {
        this.handleTierClick(tierBtn);
        return;
      }

      // Subscription toggle option
      const subOpt = target.closest('[data-subscription-option]');
      if (subOpt && this.contains(subOpt)) {
        this.handleSubscriptionClick(subOpt);
        return;
      }

      // Stepper / explicit add button
      const action = target.closest('[data-action]');
      if (action && this.contains(action)) {
        const a = action.dataset.action;
        const card = action.closest('.cpb-flavor');
        if (!card) return;

        if (a === 'add' || a === 'increment') {
          this.handleAddFlavor(card);
        } else if (a === 'decrement') {
          this.handleRemoveFlavor(card);
        }
        return;
      }

      // Tap anywhere on the card body (name / descriptor area) → +1.
      // Excludes the relleno tag (which has its own tooltip behaviour)
      // and any element inside the stepper/add button (handled above).
      const flavorCard = target.closest('.cpb-flavor');
      if (flavorCard && this.contains(flavorCard)) {
        if (target.closest('[data-relleno-tag]')) return;
        this.handleAddFlavor(flavorCard);
      }
    };

    onTierKeydown = (e) => {
      const focused = document.activeElement;
      if (!focused || !focused.classList.contains('cpb-tier')) return;
      const idx = this.refs.tierButtons.indexOf(focused);
      if (idx < 0) return;

      let nextIdx = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        nextIdx = (idx + 1) % this.refs.tierButtons.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        nextIdx = (idx - 1 + this.refs.tierButtons.length) % this.refs.tierButtons.length;
      } else if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        this.handleTierClick(focused);
        return;
      }

      if (nextIdx >= 0) {
        e.preventDefault();
        this.refs.tierButtons[nextIdx].focus();
      }
    };

    onGiftInput = () => {
      const input = this.refs.giftInput;
      if (!input) return;
      const text = input.value.trim();
      const words = text ? text.split(/\s+/).filter(Boolean) : [];
      let count = words.length;

      if (count > 20) {
        input.value = words.slice(0, 20).join(' ');
        count = 20;
      }

      this.state.giftMessage = input.value.trim();
      if (this.refs.giftWordCount) this.refs.giftWordCount.textContent = String(count);
    };

    /* ------------------------------------------------------------
       Tier handling
       ------------------------------------------------------------ */
    handleTierClick(tierBtn) {
      const newMax = parseInt(tierBtn.dataset.cookieCount, 10) || 0;
      const total = this.totalSelected();

      if (total > newMax) {
        // Downgrade with overflow → modal
        this.openTrimModal(tierBtn, newMax);
        return;
      }

      this.applyTierChange(tierBtn);
    }

    applyTierChange(tierBtn) {
      this.refs.tierButtons.forEach((btn) => {
        const isSelected = btn === tierBtn;
        btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        btn.classList.toggle('cpb-tier--selected', isSelected);
      });

      this.state.variantId    = tierBtn.dataset.variantId;
      this.state.variantTitle = tierBtn.dataset.tierName;
      this.state.priceCents   = parseInt(tierBtn.dataset.priceCents, 10) || 0;
      this.state.maxCount     = parseInt(tierBtn.dataset.cookieCount, 10) || 0;

      this.renderAll();
    }

    /* ------------------------------------------------------------
       Modal — clone from <template>, focus-trap, ESC, backdrop close
       ------------------------------------------------------------ */
    openTrimModal(targetTierBtn, newMax) {
      if (!this.refs.modalTemplate) return;

      this.lastFocusedTrigger = targetTierBtn;

      const fragment = this.refs.modalTemplate.content.cloneNode(true);
      const modal = fragment.querySelector('[data-modal]');
      if (!modal) return;

      const tierName = targetTierBtn.dataset.tierName || '';
      const tierEl = modal.querySelector('[data-modal-tier]');
      const maxEl = modal.querySelector('[data-modal-max]');
      const max2El = modal.querySelector('[data-modal-max-2]');
      if (tierEl)  tierEl.textContent  = tierName;
      if (maxEl)   maxEl.textContent   = String(newMax);
      if (max2El)  max2El.textContent  = String(newMax);

      const cancelBtn  = modal.querySelector('[data-modal-cancel]');
      const confirmBtn = modal.querySelector('[data-modal-confirm]');
      const backdrop   = modal.querySelector('[data-modal-backdrop]');

      const close = () => {
        modal.removeEventListener('keydown', onKeydown);
        modal.remove();
        if (this.lastFocusedTrigger) this.lastFocusedTrigger.focus();
      };

      const onKeydown = (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          return;
        }
        if (e.key === 'Tab') {
          // Focus trap: keep focus within [cancel, confirm]
          const focusables = [cancelBtn, confirmBtn].filter(Boolean);
          if (!focusables.length) return;
          const first = focusables[0];
          const last  = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      };

      if (cancelBtn)  cancelBtn.addEventListener('click', close);
      if (backdrop)   backdrop.addEventListener('click', close);
      if (confirmBtn) confirmBtn.addEventListener('click', () => {
        this.trimSelectionsTo(newMax);
        this.applyTierChange(targetTierBtn);
        close();
      });

      modal.addEventListener('keydown', onKeydown);

      this.appendChild(modal);
      // Focus the confirm button (primary action) after mount
      requestAnimationFrame(() => {
        if (confirmBtn) confirmBtn.focus();
      });
    }

    /* ------------------------------------------------------------
       FIFO trim — Map preserves insertion order. We trim from the
       LAST inserted entries first (LIFO from the user's perspective:
       newest-added cookies are removed). Plan says FIFO meaning
       "keep the first N", which is the same as removing newest first
       in a Map iterated in insertion order. We iterate forward and
       cap each entry's qty until total equals newMax.
       ------------------------------------------------------------ */
    trimSelectionsTo(newMax) {
      if (this.totalSelected() <= newMax) return;

      // Walk forward, accumulate; once sum exceeds newMax, cap and zero rest
      let running = 0;
      const newSelections = new Map();
      for (const [slug, entry] of this.state.selections.entries()) {
        if (running >= newMax) break;
        const remainingCapacity = newMax - running;
        const keep = Math.min(entry.qty, remainingCapacity);
        if (keep > 0) {
          newSelections.set(slug, { ...entry, qty: keep });
          running += keep;
        }
      }
      this.state.selections = newSelections;
    }

    /* ------------------------------------------------------------
       Add / remove a flavor
       ------------------------------------------------------------ */
    handleAddFlavor(card) {
      const slug = card.dataset.flavourSlug;
      if (!slug) return;
      const total = this.totalSelected();

      if (total >= this.state.maxCount) {
        // Overflow → shake + toast with upgrade option
        this.triggerOverflow(card);
        return;
      }

      const current = this.state.selections.get(slug);
      const newQty = (current?.qty || 0) + 1;

      this.state.selections.set(slug, {
        qty: newQty,
        name: card.dataset.flavourName || slug,
        descriptor: card.dataset.flavourDescriptor || '',
        image: card.dataset.flavourImage || '',
        relleno: card.dataset.flavourRelleno === 'true',
        rellenoDesc: card.dataset.flavourRellenoDesc || '',
      });

      this.pulseCard(card);
      this.renderAll();
    }

    handleRemoveFlavor(card) {
      const slug = card.dataset.flavourSlug;
      if (!slug) return;
      const current = this.state.selections.get(slug);
      if (!current || current.qty <= 0) return;

      const newQty = current.qty - 1;
      if (newQty <= 0) {
        this.state.selections.delete(slug);
      } else {
        this.state.selections.set(slug, { ...current, qty: newQty });
      }
      this.renderAll();
    }

    pulseCard(card) {
      card.classList.remove('cpb-flavor--pulse');
      // Force reflow so animation restarts cleanly
      // eslint-disable-next-line no-unused-expressions
      void card.offsetWidth;
      card.classList.add('cpb-flavor--pulse');
      setTimeout(() => card.classList.remove('cpb-flavor--pulse'), 240);
    }

    /* ------------------------------------------------------------
       Overflow handling
       ------------------------------------------------------------ */
    triggerOverflow(card) {
      // Shake the card
      card.classList.remove('cpb-flavor--shake');
      void card.offsetWidth;
      card.classList.add('cpb-flavor--shake');
      setTimeout(() => card.classList.remove('cpb-flavor--shake'), 320);

      // Find next tier (by index) — only offer upgrade if one exists
      const currentIdx = this.refs.tierButtons.findIndex(
        (b) => b.dataset.variantId === this.state.variantId
      );
      const nextTier = currentIdx >= 0 && currentIdx < this.refs.tierButtons.length - 1
        ? this.refs.tierButtons[currentIdx + 1]
        : null;

      const tierName = this.state.variantTitle;
      const slug = card.dataset.flavourSlug;

      if (nextTier) {
        const nextName = nextTier.dataset.tierName;
        this.showToast({
          message: `Tu pack ${tierName} está completo. Sube a ${nextName} para añadir más.`,
          actionLabel: 'Subir pack',
          onAction: () => {
            // Apply upgrade then perform the original add
            this.applyTierChange(nextTier);
            // After upgrade, re-add the cookie
            this.handleAddFlavor(card);
            // Dispatch custom event for any external listeners
            this.dispatchEvent(new CustomEvent('cpb:upgrade-tier', {
              detail: { from: tierName, to: nextName, slug },
              bubbles: true,
            }));
          },
        });
      } else {
        this.showToast({
          message: `Tu pack ${tierName} ya está completo.`,
        });
      }
    }

    onUpgradeTier = () => {
      // Hook for external listeners; nothing to do internally
    };

    /* ------------------------------------------------------------
       Toast region (role="status" aria-live="polite")
       ------------------------------------------------------------ */
    showToast({ message, actionLabel, onAction, duration = 4000 }) {
      const region = this.refs.toastRegion;
      if (!region) return;

      // Replace any existing toast — we only show one at a time
      region.innerHTML = '';
      if (this.toastTimer) clearTimeout(this.toastTimer);

      const toast = document.createElement('div');
      toast.className = 'cpb-toast';

      const msg = document.createElement('span');
      msg.className = 'cpb-toast__msg';
      msg.textContent = message;
      toast.appendChild(msg);

      if (actionLabel && typeof onAction === 'function') {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cpb-toast__action';
        btn.textContent = actionLabel;
        btn.addEventListener('click', () => {
          onAction();
          this.dismissToast(toast);
        });
        toast.appendChild(btn);
      }

      region.appendChild(toast);

      this.toastTimer = setTimeout(() => this.dismissToast(toast), duration);
    }

    dismissToast(toast) {
      if (!toast || !toast.isConnected) return;
      toast.classList.add('is-leaving');
      setTimeout(() => toast.remove(), 240);
    }

    /* ------------------------------------------------------------
       Subscription toggle
       ------------------------------------------------------------ */
    handleSubscriptionClick(btn) {
      const value = btn.dataset.subscriptionOption;
      const isSubscribing = value === 'subscribe';
      if (this.state.isSubscribing === isSubscribing) return;

      this.state.isSubscribing = isSubscribing;

      this.refs.subOptions.forEach((opt) => {
        const active = opt === btn;
        opt.classList.toggle('cpb-sub-toggle__option--active', active);
        opt.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      this.renderTotal();
      this.renderCTA();
    }

    /* ------------------------------------------------------------
       Computed state helpers
       ------------------------------------------------------------ */
    totalSelected() {
      let sum = 0;
      for (const entry of this.state.selections.values()) sum += entry.qty;
      return sum;
    }

    effectivePriceCents() {
      const base = this.state.priceCents;
      if (this.state.isSubscribing && this.config.spDiscountPct > 0) {
        return Math.round(base * (1 - this.config.spDiscountPct / 100));
      }
      return base;
    }

    formatPrice(cents) {
      return formatMoney(cents, this.config.moneyFormat, this.config.currency);
    }

    /* ------------------------------------------------------------
       Render orchestrator
       ------------------------------------------------------------ */
    renderAll() {
      const total = this.totalSelected();
      const max = this.state.maxCount;
      const wasComplete = this.state.isComplete;
      const isComplete = max > 0 && total === max;
      this.state.isComplete = isComplete;

      this.renderFlavors(total, max);
      this.renderCapacityGrid(total, max);
      this.renderProgress(total, max);
      this.renderStatus(total, max, isComplete);
      this.renderTotal();
      this.renderCTA();

      // Pack-complete celebration — fire only on fresh transition
      this.classList.toggle('cpb--complete', isComplete);
      if (isComplete && !wasComplete) {
        this.fireSparkle();
      }
    }

    renderFlavors(total, max) {
      const atCapacity = max > 0 && total >= max;
      this.refs.flavorCards.forEach((card) => {
        const slug = card.dataset.flavourSlug;
        const entry = this.state.selections.get(slug);
        const qty = entry?.qty || 0;

        // Update count badge
        const badge = card.querySelector('[data-count-badge]');
        const badgeNum = card.querySelector('[data-count]');
        if (badge && badgeNum) {
          if (qty > 0) {
            badgeNum.textContent = String(qty);
            if (badge.hasAttribute('hidden')) {
              badge.removeAttribute('hidden');
            }
          } else {
            badge.setAttribute('hidden', '');
          }
        }

        // Update stepper visibility & qty
        const stepper = card.querySelector('[data-stepper]');
        const stepperQty = card.querySelector('[data-stepper-qty]');
        if (stepper) {
          if (qty > 0) {
            stepper.removeAttribute('hidden');
          } else {
            stepper.setAttribute('hidden', '');
          }
        }
        if (stepperQty) stepperQty.textContent = String(qty);

        // Selected ring + dimming
        card.classList.toggle('is-selected', qty > 0);
        card.dataset.count = String(qty);

        const dim = atCapacity && qty === 0;
        card.classList.toggle('is-dimmed', dim);

        // Plus disabled when at capacity and this card has no selection
        const plusBtn = card.querySelector('[data-action="increment"]');
        if (plusBtn) plusBtn.disabled = atCapacity && qty === 0;

        // Update aria-label to include count
        const baseName = card.dataset.flavourName || '';
        const relleno = card.dataset.flavourRelleno === 'true';
        const rellenoBit = relleno ? ', rellena' : '';
        const countBit = qty > 0 ? `, ${qty} seleccionada${qty === 1 ? '' : 's'}` : '';
        card.setAttribute('aria-label', `Galleta ${baseName}${rellenoBit}${countBit}`);
      });
    }

    renderCapacityGrid(total, max) {
      const slots = this.refs.capacitySlots;
      if (!slots.length) return;

      // Build an ordered list of thumbnails: one per cookie, in the order
      // they were added (Map insertion order).
      const thumbnails = [];
      for (const [slug, entry] of this.state.selections.entries()) {
        for (let i = 0; i < entry.qty; i++) {
          thumbnails.push({ slug, image: entry.image, name: entry.name });
        }
      }

      slots.forEach((slot, idx) => {
        const inTier = idx < max;
        const filled = idx < thumbnails.length;
        const t = filled ? thumbnails[idx] : null;

        slot.classList.toggle('is-out-of-tier', !inTier);
        slot.classList.toggle('is-filled', filled);

        if (filled && t && t.image) {
          slot.style.backgroundImage = `url("${t.image}")`;
          slot.title = t.name || '';
        } else {
          slot.style.backgroundImage = '';
          slot.removeAttribute('title');
        }
      });
    }

    renderProgress(total, max) {
      const safeMax = Math.max(max, 1);
      const p = this.refs.progress;
      if (p) {
        p.value = total;
        p.max = safeMax;
        p.setAttribute('aria-valuetext', `${total} de ${max} galletas`);
      }
      const mp = this.refs.mobileProgress;
      if (mp) {
        mp.value = total;
        mp.max = safeMax;
      }
    }

    renderStatus(total, max, isComplete) {
      const empty = this.refs.summaryEmpty;
      const progress = this.refs.summaryProgress;
      const completeCap = this.refs.completeCaption;

      if (empty)    empty.toggleAttribute('hidden', total > 0);
      if (progress) progress.toggleAttribute('hidden', total === 0 || isComplete);
      if (completeCap) completeCap.toggleAttribute('hidden', !isComplete);

      if (this.refs.selectedCount) this.refs.selectedCount.textContent = String(total);
      if (this.refs.capacityText)  this.refs.capacityText.textContent  = String(max);
      if (this.refs.mobileCapacity) this.refs.mobileCapacity.textContent = `${total} / ${max}`;
    }

    renderTotal() {
      const wrap = this.refs.totalPrice;
      if (!wrap) return;
      const cents = this.effectivePriceCents();
      const formatted = this.formatPrice(cents);

      const current = wrap.textContent.trim();
      if (current === formatted.trim()) return;

      // Animated swap: leaving copy + entering copy
      const leaving = document.createElement('span');
      leaving.className = 'cpb-summary__total-price-outgoing';
      leaving.textContent = current;

      const entering = document.createElement('span');
      entering.className = 'cpb-summary__total-price-incoming';
      entering.textContent = formatted;

      wrap.innerHTML = '';
      wrap.appendChild(leaving);
      wrap.appendChild(entering);
      wrap.classList.add('is-changing');

      setTimeout(() => {
        wrap.textContent = formatted;
        wrap.classList.remove('is-changing');
      }, 240);
    }

    renderCTA() {
      const ctas = this.refs.ctas;
      const texts = this.refs.ctaTexts;
      if (!ctas.length || !texts.length) return;

      const total = this.totalSelected();
      const max = this.state.maxCount;
      const remaining = Math.max(0, max - total);
      const formatted = this.formatPrice(this.effectivePriceCents());

      const isReady = max > 0 && total === max && !this.state.isSubmitting;

      const setDisabled = (value) => ctas.forEach((c) => { c.disabled = value; });
      const setText = (value) => texts.forEach((t) => { t.textContent = value; });

      if (this.state.isSubmitting) {
        setDisabled(true);
        setText('Añadiendo…');
        return;
      }

      if (!isReady) {
        setDisabled(true);
        if (max === 0) {
          setText('Configurando pack…');
        } else if (remaining > 0) {
          setText(`Faltan ${remaining} galleta${remaining === 1 ? '' : 's'}`);
        } else {
          setText('Selecciona tus galletas');
        }
        return;
      }

      setDisabled(false);
      if (this.state.isSubscribing && this.config.spDiscountPct > 0) {
        setText(`Suscribirme — ${formatted} (ahorras ${this.config.spDiscountPct}%)`);
      } else if (this.state.isSubscribing) {
        setText(`Suscribirme — ${formatted}`);
      } else {
        setText(`Añadir mi pack — ${formatted}`);
      }
    }

    /* ------------------------------------------------------------
       Pack-complete: sparkle burst (one-shot)
       ------------------------------------------------------------ */
    fireSparkle() {
      const summary = this.refs.summary;
      if (!summary) return;

      // Insert sparkle dots
      const sparkle = document.createElement('span');
      sparkle.className = 'cpb-sparkle';
      sparkle.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < 6; i++) {
        const dot = document.createElement('span');
        dot.className = 'cpb-sparkle__dot';
        sparkle.appendChild(dot);
      }
      summary.appendChild(sparkle);

      this.classList.add('cpb--sparkle');
      if (this.completePulseTimer) clearTimeout(this.completePulseTimer);
      this.completePulseTimer = setTimeout(() => {
        this.classList.remove('cpb--sparkle');
        sparkle.remove();
      }, 700);
    }

    /* ------------------------------------------------------------
       Cart submission
       ------------------------------------------------------------ */
    onSubmit = async (e) => {
      if (!this.refs.ctas.length) return;
      if (this.refs.ctas.every((c) => c.disabled)) return;
      if (this.state.isSubmitting) return;

      // Make sure we're complete
      if (this.totalSelected() !== this.state.maxCount || this.state.maxCount === 0) return;

      this.state.isSubmitting = true;
      this.refs.ctas.forEach((c) => c.classList.add('is-submitting'));
      this.refs.ctaSpinners.forEach((s) => s.removeAttribute('hidden'));
      this.renderCTA();

      try {
        const item = this.buildCartPayload();
        const requestBody = { items: [item] };

        // If the theme has a cart-drawer / cart-notification component,
        // render its sections after add. Mirrors Dawn's pattern.
        const cartHost =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartHost && typeof cartHost.getSectionsToRender === 'function') {
          try {
            requestBody.sections = cartHost.getSectionsToRender().map((s) => s.id);
            requestBody.sections_url = window.location.pathname;
            if (typeof cartHost.setActiveElement === 'function') {
              cartHost.setActiveElement(document.activeElement);
            }
          } catch { /* non-fatal */ }
        }

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(requestBody),
        });

        const data = await res.json();
        if (!res.ok || data.status) {
          throw new Error(data.message || data.description || 'Error al añadir al carrito');
        }

        // Dispatch a Shopify-style cart update for any listeners
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { source: 'cookie-pack-builder', cart: data },
        }));

        if (cartHost && typeof cartHost.renderContents === 'function') {
          try { cartHost.renderContents(data); } catch { /* fall through */ }
        } else {
          // No cart drawer — go to /cart so customer sees the item
          window.location.href = '/cart';
          return;
        }

        // Success: brief confirmation, then reset
        this.refs.ctaTexts.forEach((t) => { t.textContent = '✓ Añadido'; });
        setTimeout(() => this.resetAfterSuccess(), 1500);

      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[cookie-pack-builder] cart add failed:', err);
        this.showToast({
          message: err.message || 'No hemos podido añadir el pack. Inténtalo de nuevo.',
        });
        this.state.isSubmitting = false;
        this.refs.ctas.forEach((c) => c.classList.remove('is-submitting'));
        this.refs.ctaSpinners.forEach((s) => s.setAttribute('hidden', ''));
        this.renderCTA();
      }
    };

    buildCartPayload() {
      // Insertion-order entries (Map preserves it). First entry = first-added cookie,
      // used as the cart line-item image fallback since the pack product has no media.
      const insertionEntries = Array.from(this.state.selections.entries())
        .filter(([, e]) => e.qty > 0);

      // Sort alphabetically by slug for deterministic _pack_config / Cookies values.
      const entries = insertionEntries.slice().sort(([a], [b]) => a.localeCompare(b));

      const packConfig = entries.map(([slug, e]) => `${slug}:${e.qty}`).join(',');
      const cookies    = entries.map(([, e]) => `${e.qty}× ${e.name}`).join(', ');

      const properties = {
        _pack_config: packConfig,
        Cookies: cookies,
      };

      const firstImage = insertionEntries[0]?.[1]?.image;
      if (firstImage) {
        properties._pack_image = firstImage;
      }

      const gift = (this.state.giftMessage || '').trim();
      if (gift) {
        properties['Mensaje regalo'] = gift;
        properties['_gift_message'] = gift;
      }

      const payload = {
        id: this.state.variantId,
        quantity: 1,
        properties,
      };

      if (this.state.isSubscribing && this.config.spPlanId) {
        payload.selling_plan = this.config.spPlanId;
      }

      return payload;
    }

    resetAfterSuccess() {
      this.state.selections = new Map();
      this.state.giftMessage = '';
      this.state.isComplete = false;
      this.state.isSubmitting = false;

      if (this.refs.giftInput) this.refs.giftInput.value = '';
      if (this.refs.giftWordCount) this.refs.giftWordCount.textContent = '0';
      this.refs.ctas.forEach((c) => c.classList.remove('is-submitting'));
      this.refs.ctaSpinners.forEach((s) => s.setAttribute('hidden', ''));

      this.classList.remove('cpb--complete', 'cpb--sparkle');
      this.renderAll();
    }
  }

  customElements.define('cookie-pack-builder', CookiePackBuilder);
})();
